import type {
  LC_GetCurrentWeekOut,
  LC_GetDailyStatusOut,
  LC_DashboardMonthlyOut,
  LC_TodayMarkItem,
  AttendanceDashboard,
  AttendanceStatus,
  DashboardMark,
  DashboardMonthly,
  DashboardWeekly,
  DayStatus,
} from '../types';


const FREE_SCHEDULE_DESCRIPTION = 'Libre';

const COLOR_CATEGORY_TO_MARK_TYPE: Record<string, DashboardMark['markType']> = {
  verde: 'on_time',
  amarillo: 'late',
  azul: 'overtime',
};

function buildCurrentWeek(today: Date) {
  const monday = new Date(today);
  monday.setDate(today.getDate() - ((today.getDay() + 6) % 7));

  return Array.from({ length: 7 }, (_, i) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    return {
      dayIndex: i,
      dayNumber: day.getDate(),
      status: 'pending' as const,
    };
  });
}

export function mapTodayMarks(transport: LC_TodayMarkItem[]): DashboardMark[] {
  return (transport ?? []).map((item) => ({
    time: item.time,
    description: item.description,
    modality: item.modality,
    markType: COLOR_CATEGORY_TO_MARK_TYPE[item.colorCategory] ?? 'on_time',
  }));
}

const COLOR_CATEGORY_TO_DAY_STATUS: Record<string, DayStatus> = {
  verde: 'complete',
  azul: 'overtime',
  amarillo: 'late',
  rojo: 'absent',
  pendiente: 'pending',
};

export function mapCurrentWeek(transport: LC_GetCurrentWeekOut): DashboardWeekly {
  return {
    days: transport.days.map((day, index) => ({
      dayIndex: index,
      dayNumber: parseInt(day.date.split('-')[2], 10),
      status: COLOR_CATEGORY_TO_DAY_STATUS[day.colorCategory] ?? 'pending',
    })),
    workedHours: transport.workedHours,
    totalHours: transport.theoreticalHours,
  };
}

export function mapDashboardMonthly(transport: LC_DashboardMonthlyOut): DashboardMonthly {
  return {
    overtime: transport.overtime,
    tardiness: transport.tardiness,
    absences: transport.absences,
    marks: transport.marks,
  };
}

export function mapDashboard(transport: LC_GetDailyStatusOut, today: Date): AttendanceDashboard {
  const { status, statusCode, schedule, marks, metrics } = transport;

  return {
    situation: {
      status: statusCode as AttendanceStatus,
      statusLabel: status,
      scheduleEntry: schedule.entry,
      scheduleExit: schedule.exit,
      lunchBreak: schedule.lunchBreak,
      isFreeSchedule: schedule.description === FREE_SCHEDULE_DESCRIPTION,
      hasSchedule: schedule.entry != null && schedule.exit != null,
      marksEntry: marks.entry,
      marksExit: marks.exit,
      metrics: [
        { labelKey: 'attendance:dashboard.situationCard.metrics.absence',    value: metrics.absenceHours },
        { labelKey: 'attendance:dashboard.situationCard.metrics.overtime',   value: metrics.overtimeHours },
        { labelKey: 'attendance:dashboard.situationCard.metrics.workedHours',value: metrics.totalWorkedHours },
      ],
    },
    weekly: {
      days: buildCurrentWeek(today),
      workedHours: '0',
      totalHours: '0',
    },
  };
}
